// Search over the Key Rivers & Mountains features: a fixed list of 20
// names, matched client-side with the static-search rules (2-char queries
// match name starts, 3+ match substrings, diacritic-folded) and merged
// into the search results ahead of the data-backed kinds.
import { searchFold } from './staticSearch.js';
import { KEY_RIVERS, MOUNTAIN_RANGES } from '../data/geoFeatures.js';

const ENTRIES = [
  ...KEY_RIVERS.map((n) => ({ kind: 'river', id: n, label: n })),
  ...MOUNTAIN_RANGES.map((r) => ({ kind: 'mountain', id: r.name, label: r.name })),
];

export function searchGeoFeatures(query) {
  const q = searchFold(String(query ?? '').trim());
  if (q.length < 2) return [];
  return ENTRIES.filter((e) => {
    const n = searchFold(e.label);
    return q.length === 2 ? n.startsWith(q) : n.includes(q);
  });
}
